import React, { useEffect } from 'react';

export const GoogleReview: React.FC = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://elfsightcdn.com/platform.js';
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <>
      <div className="elfsight-app-5bc34526-bde0-4e06-b4c4-289a64b1b8a0" data-elfsight-app-lazy />
    </>
  );
};
